(function ($) {
    /// <summary>
    /// jQuery UI widget for managing a mini calendar section.
    /// </summary>
    $.widget("ui.LunchMenuCalendar",
        {
            options:
            {
                ReturnPageUrl: null,
                /// <summary>
                /// Callback function used to merge in extra post database to to SelectMonthUrl.
                /// Callback is to returned the merged data.
                /// function (aOriginalData)
                /// </summary>
                MergeExtraPostData: null,
                /// <summary>
                /// Url from which provides the big calendar view.
                /// </summary>
                SubscribeUrl: null,
                /// <summary>
                /// Url from which provides the big calendar view.
                /// </summary>
                GridUrl: null,
                /// <summary>
                /// Initially selected month.
                /// </summary>
                SelectedMonth: null,
                /// <summary>
                /// Html to display in the grid area while loading new events from the server.
                /// </summary>
                LoadingHTML: '<div class="fbcms_calendar_grid_loading">'
                    + '<img src="/img/spacer.gif" alt="Loading Lunch Menu..." title="Loading Lunch Menu..."/>'
                    + '<div>Loading Lunch Menu...</div>'
                    + '</div><!-- .fbcms_calendar_grid_loading //-->',
                /// <summary>
                /// Html to show in the grid area if an error occurred loading events from the server.
                /// </summary>
                ErrorHTML: '<div class="fbcms_calendar_grid_error">'
                    + '<img src="/img/spacer.gif" alt="Error Loading Lunch Menu." title="Error Loading Lunch Menu."/>'
                    + '<div>Error Loading Lunch Menu.</div>'
                    + '</div><!-- .fbcms_calendar_grid_error //-->'
            },

            /// <summary>
            /// jQuery UI widget destroy.
            /// </summary>
            _destroy: function () {
                return undefined;
            },

            /// <summary>
            /// jQuery UI widget init.
            /// </summary>
            _init: function () {
                return undefined;
            },

            /// <summary>
            /// jQuery UI widget create.
            /// </summary>
            _create: function () {
                const self = this;
                const jElement = $(self.element);

                jElement.on('click', '.ical_show_button',
                    function (aEvent) {
                        aEvent.preventDefault();
                        subscribeToCalendars(self.options.SubscribeUrl);
                    }
                );

                jElement.on('click', '.next_button',
                    function (aEvent) {
                        aEvent.preventDefault();
                        self.ChangeMonth(null, 'Next');
                    }
                );

                jElement.on('click', '.previous_button',
                    function (aEvent) {
                        aEvent.preventDefault();
                        self.ChangeMonth(null, 'Previous');
                    }
                );

                jElement.on('change', 'select[name=month]', function (e)  //ignore jslint
                {
                    self.ChangeMonth($(this).val());
                });

                jElement.on('click', 'button.lunchmenu-printme-button', function (e)
                {

                    function setPrint()
                    {
                        const closePrint = () =>
                        {
                            document.body.removeChild(this);
                        };
                        this.contentWindow.onbeforeunload = closePrint;
                        this.contentWindow.onafterprint = closePrint;
                        this.contentWindow.print();
                    }

                    const printUrl = $(this).data('printurl');
                    // $.get(printUrl, function (data) {
                    //     const fullHtml = data;
                    //     const printWindow = window.open('', '_blank');
                    //     printWindow.document.write(fullHtml);
                    //     printWindow.document.close(); // Finalize the document
                    //     printWindow.onload = function () {
                    //         printWindow.print(); // Trigger print dialog
                    //         printWindow.close(); // Close window after printing (optional)
                    //     };
                    // });


                    const hideFrame = document.createElement("iframe");
                    hideFrame.onload = setPrint;
                    hideFrame.style.display = "none"; // hide iframe
                    hideFrame.src = printUrl;
                    document.body.appendChild(hideFrame);


                });

                self.GetSelectedMonth();
            },

            ChangeMonth: function (aMonth, aButtonClicked) {
                const self = this;
                const jElement = $(self.element);
                jElement.html(self.options.LoadingHTML);

                if (aMonth !== undefined && aMonth !== null) {
                    self.options.SelectedMonth = self.GetSelectedMonth(aMonth);
                }

                let lMyData = {
                    'IsPrintView': self.options.IsPrintView,
                    'ReturnPageUrl': self.options.ReturnPageUrl,
                    'Month': self.options.SelectedMonth,
                    'ButtonClicked': (aButtonClicked === undefined) ? '' : aButtonClicked,
                    'rndm': Math.random()
                };

                if (typeof self.options.MergeExtraPostData === 'function') {
                    lMyData = self.options.MergeExtraPostData(lMyData);
                }

                $.ajax(self.options.GridUrl, {
                    success: function (data, textStatus, jqXHR) //ignore jslint
                    {
                        jElement.html(data);
                        self.options.SelectedMonth = jElement.find("input.selected_month").val();
                    },
                    error: function (jqXHR, textStatus, errorThrown) //ignore jslint
                    {
                        jElement.html(self.options.ErrorHTML);
                    },
                    data: lMyData,
                    type: 'POST'
                });
            },

            /// <summary>
            /// Returns the current selected month.
            /// </summary>
            GetSelectedMonth: function (aDateString) {
                let lSelectedMonth;
                if (aDateString === undefined || aDateString === null) {
                    lSelectedMonth = this.options.SelectedMonth;
                }
                else {
                    lSelectedMonth = aDateString;
                }
                return lSelectedMonth;
            }
        });
}(jQuery));
